import React from 'react'
import ViewAllEv from '../../../Layout/Dashboard/ViewAll'

const ViewAllEvent = () => {
  return <ViewAllEv />
}

export default ViewAllEvent
